import React, { memo } from "react";
import { Form } from 'react-bootstrap';

const CustomInput = ({ label, handleChange, ids, value, validate, disabled, type = 'text', step=null, handleBlur }) => {
  return (
    <Form.Group controlId={ids} >
      {label ? (
        <Form.Label>{label}<span className="text-danger">{validate ? "*" : null}</span></Form.Label>
      ) : null}

      <Form.Control
        type={type}
        disabled={disabled}
        name={ids}
        onChange={handleChange}
        onBlur={handleBlur}
        value={value}
        required={validate}
        step={step ? step : undefined}
      />
      {validate ? (
        <Form.Control.Feedback type="invalid">
          {label ? label : ids} is required

        </Form.Control.Feedback>
      ) : null}

    </Form.Group>
  )
}

export default memo(CustomInput);
